<!-- SCHEDULED FOR DEVELOPMENT IN Q1 2022 -->
<template>
  <div class="callerComponent" :class="{activeCall: callIsLive, default: outbound, inactiveCall: !outbound && !callIsLive, pulse: callIsLive}">
    <div v-if="callIsLive && !outbound" class="liveSection">
      <div class="liveWrapper">
        <div class="callLive"></div> 
        <div v-if="callingTo.callFrom && callingTo.name.length > 1">
          <div class="nameLabel">
            {{callingTo.name}}
          </div>
          <div class="subLabel">
            {{callingTo.number}}
          </div>
        </div>
        <div v-else-if="callingTo.callFrom">
            <div class="nameLabel">
               {{callingTo.number}}
            </div>
        </div>
      </div>
      <div>
        <img :src="callingTo.callFromImg" v-if="callingTo.callFromImg" class="callFromImg">
        <div v-if='!callingTo.callFromImg && callingTo.callFrom' class="callFromInitial">
          {{callingTo.callFrom[0] + callingTo.callFrom.split(' ')[1][0]}}
        </div>
      </div>
    </div>
    <div class="callOB" v-else-if="outbound">
     <i class="zmdi zmdi-long-arrow-tab"></i>
     <div v-if="callingTo.name && callingTo.name.length > 1">
        <div class="nameLabel">
          {{callingTo.name}}
        </div>
        <div class="subLabel">
          {{callingTo.number}}
        </div>
     </div>
     <div v-else class="nameLabel number">
       {{callingTo.number}}
     </div>
    </div>
    <div class="callMissing" v-else>
      NO CALLS AT {{extension}}
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import { mapState, mapGetters } from 'vuex' 
import axios from 'axios';
require('../assets/css/caller.css')

  export default {
    name: 'caller',
    props: [],
    watch:{
      conversation: async function(newConvo){
        this.callingTo.callFromImg = this.user.Phonecode.pc_avatar
        this.callingTo.callFrom = this.user.descrip1
        this.callingTo.callFromID = this.user.leuserid
      }
    },
    data: function () {
      return {
        callIsLive: false,
        extension: '123-456-7891',
        callingTo:{
          name: 'Customer McPerson',
          number:'908-285-2006',
          callFrom: 'Tim Gaz',
          callFromImg: '',
          callFromID: '', 
        },
        outbound: false
      }
    },
    computed: {
      ...mapState({
        user: state => state.user,
        account: state => state.account,
        conversation: state => state.conversation,
        conversationOwner: state => state.conversationOwner,
        preferredOutboundDnis: state => state.preferredOutboundDnis,
        call (state) {
          return state.currentMessages[state.currentMessages.length -1]
        },
      })
    },
    methods: {
     
      
    }
  }
</script>
